import React, { FC, useEffect } from "react"
import { Route, Routes } from "react-router-dom"
import { EPath } from "./EPath"
import Contract from "../Features/Review/Contract"
import CreateTemplate from "../Features/Drafting/Templates/CreateTemplate/CreateTemplate"
import EditTemplate from "../Features/Drafting/Templates/EditTemplate/EditTemplate"
import CreateDraft from "../Features/Drafting/Drafts/CreateDraft/CreateDraft"
import EditDraft from "../Features/Drafting/Drafts/EditDraft/EditDraft"
import { useLocation } from "react-router-dom";
import useAnalytics from "../Analytics/Analytics"
import Review from "../Features/Review/Review"
import PageNotFoundScreen from "../Components/Misc/PageNotFoundScreen"

interface IResellerRouterProps {
    language: string;
}

const ResellerRouter: FC<IResellerRouterProps> = ({ language }) => {
    const location = useLocation();

    const { trackEvent, EventTypes } = useAnalytics();

    useEffect(() => {
        trackEvent(EventTypes.VIEW);
    }, [EventTypes.VIEW, location, trackEvent]);
    
    return (
        <Routes>
            <Route path={EPath.REVIEW_COPILOT} element={<Contract selectedTab={0} lang={language} />} />
            <Route path={EPath.REVIEW_DETAIL} element={<Contract selectedTab={1} lang={language} />} />
            <Route path={EPath.REVIEW_ANONYMISATION} element={<Contract selectedTab={2} lang={language}/>} />
            
            {/* Drafting */}
            <Route path={EPath.DRAFT_CREATE} element={<CreateDraft />} />
            <Route path={EPath.DRAFT_DETAIL} element={<EditDraft />} />
            <Route path={EPath.TEMPLATE_CREATE} element={<CreateTemplate />} />
            <Route path={EPath.TEMPLATE_DETAIL} element={<EditTemplate />} />

            <Route path="*" element={<PageNotFoundScreen />} />
        </Routes>
    )
}

export default ResellerRouter